import { render, staticRenderFns } from "./JuniorBusiness.vue?vue&type=template&id=1a85b079&scoped=true"
import script from "./JuniorBusiness.vue?vue&type=script&lang=js"
export * from "./JuniorBusiness.vue?vue&type=script&lang=js"
import style0 from "./JuniorBusiness.vue?vue&type=style&index=0&id=1a85b079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85b079",
  null
  
)

export default component.exports